import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@/components/molecules';
import { GRNList } from '@/components/organisms/GRN/GRNList';
import { GRNForm } from '@/components/organisms/GRN/GRNForm';

export default function GRNsPage() {
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleCreateSuccess = (grnId: string) => {
    setIsCreateModalOpen(false);
    navigate(`/grns/${grnId}`);
  };

  return (
    <div className="space-y-6">
      <GRNList onCreateClick={() => setIsCreateModalOpen(true)} />

      <Modal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        title="Create GRN"
        size="xl"
      >
        <GRNForm onSuccess={handleCreateSuccess} onCancel={() => setIsCreateModalOpen(false)} />
      </Modal>
    </div>
  );
}
